import { Component, OnInit, Input } from '@angular/core';
import { LoginService } from '../services/login.service';
import { MainModuleType } from '../models/application-models/main-module-type';
import { faBars, faUser } from '@fortawesome/free-solid-svg-icons';
import { NavigationService } from '../services/navigation.service';
import { NavbarStatus } from '../models/application-models/navbar';
import { Router } from '@angular/router';
import { OrganisationService } from '../services/organisation.service';
import { AppInitializerService } from '../services/app-initializer.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { LanguageSettingsComponent } from './language-settings/language-settings.component';
import { faLanguage, faSignOut } from '@fortawesome/pro-duotone-svg-icons';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() logoImgUrl: string;
  @Input() moduleType: MainModuleType;
  moduleClass: string;

  faBars = faBars;
  faUser = faUser;
  faLanguage = faLanguage;
  faSignOut = faSignOut;

  constructor(
    public loginService: LoginService,
    public router: Router,
    public navigationService: NavigationService,
    public organisationService: OrganisationService,
    public appInitializerService: AppInitializerService,
    private ngbModal: NgbModal
  ) { }

  ngOnInit() {
    this.loadModuleClass();
  }

  logout(){
    this.organisationService.organisation = undefined;
    this.loginService.logout();
  }

  toggleNav(){
    let navbarStatus: NavbarStatus = this.navigationService.navbarStatus;
    if(navbarStatus === NavbarStatus.MINIMISED){
      this.navigationService.navbarStatus = NavbarStatus.OPEN;
    } else if(navbarStatus === NavbarStatus.OPEN){
      this.navigationService.navbarStatus = NavbarStatus.MINIMISED;
    }
  }

  loadModuleClass(){
    switch(this.moduleType){
      case MainModuleType.ADMINCENTRE:
        this.moduleClass = "AdminCentre";
        break;
      case MainModuleType.CONTROLCENTRE:
        this.moduleClass = "ControlCentre";
        break;
      case MainModuleType.REPORTCENTRE:
        this.moduleClass = "ReportCentre";
        break;
      case MainModuleType.CUSTOMERCENTRE:
        this.moduleClass = "CustomerCentre";
        break;
      case MainModuleType.COPCENTRE:
        this.moduleClass = "CopCentre";
        break;
      case MainModuleType.RESOURCECENTRE:
        this.moduleClass = "ResourceCentre";
        break;
      case MainModuleType.DASHBOARDCENTRE:
        this.moduleClass = "DashboardCentre";
        break;
      case MainModuleType.COMMANDCENTRE:
        this.moduleClass = "CommandCentre";
      case MainModuleType.STAGINGCENTRE:
        this.moduleClass = "StagingCentre";
        break;
      case MainModuleType.TISSLPAYCENTRE:
        this.moduleClass = "TisslPayCentre";
        break;
    }
  }

  openLangSettings(){
    const options: NgbModalOptions = {
      centered: true
    }
    const modalRef = this.ngbModal.open(LanguageSettingsComponent, options);
    modalRef.componentInstance.modalRef = modalRef;
  }
}
